import { SET_MESSAGES } from "../actions/types";

const initialState = {
  messages: null,
};

function persistReducer(state = initialState, action) {
  switch (action.type) {
    case SET_MESSAGES:
      return {
        ...state,
        messages: action.payload,
      };

    default:
      return state;
  }
}

export default persistReducer;
